import apiV2 from "@/apiConfig/api-v2";

export default {
  state() {
    return {};
  },
};
